import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react"
import { Button, Spinner } from "@puregym/ui"
import { useTranslation } from "src/i18next"
import { usePoliteMessage } from "src/providers/announcerProvider"

type Props = {
  variant?: string
  isSubmitting?: boolean
  label: string
  size?: string
} & DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export const Submit: React.FC<Props> = ({
  isSubmitting,
  type,
  label,
  ...otherProps
}) => {
  const { t } = useTranslation("common")
  const message = t("localizedStrings.infoMessages.savingChanges")

  usePoliteMessage(message, isSubmitting ?? false)

  return (
    <Button
      variant="secondary"
      aria-label={label}
      type={type ?? "submit"}
      yarn
      disabled={isSubmitting || otherProps.disabled}
      {...otherProps}
    >
      {isSubmitting && <Spinner size={"small"} />}
      {label}
    </Button>
  )
}
